import { Button, Link } from "@mui/material";
import { FC, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { useSetRecoilState } from "recoil";

import { TextInputByControl } from "@ryde/controls";
import { useOtpLogin } from "@ryde/redux";
import { loginFlowStepAtom, LoginFormFlow, OTP_LENGTH } from "@ryde/shared";

import { LoginPageFormContext } from "../login.page.form.context";
import { textboxLoginSx } from "../login.page.styled";
import { useLoginTranslation } from "../use-login-translation";
import { getButtonLoginSx } from "./login.parts.styled";

export const LoginOtpForm: FC = () => {
  const { control, getValues } = useFormContext();
  const { t } = useLoginTranslation();
  const setLoginFlowStep = useSetRecoilState(loginFlowStepAtom);
  const { loginOtp } = useOtpLogin();
  const { isNonProductionLoginColors } = useContext(LoginPageFormContext);

  const onLoginWithOtpClick = (): void => {
    const code = getValues("code");

    loginOtp(code);
  };

  return (
    <div className="LoginGenericForm">
      <div className="LoginGenericForm-FieldContainer">
        <div className="LoginGenericForm-LabelSignIn">
          {t("login.ENTER_YOUR_CODE")}
        </div>
        <TextInputByControl
          sx={textboxLoginSx}
          name="code"
          e2eData={"otp_code_login_input"}
          control={control}
          inputProps={{ maxLength: OTP_LENGTH }}
          size="small"
        />
      </div>
      <Button
        data-e2e="button-login-saml"
        variant="contained"
        color={isNonProductionLoginColors ? "inherit" : "primary"}
        sx={getButtonLoginSx(isNonProductionLoginColors)}
        onClick={onLoginWithOtpClick}
      >
        {t("login.LOGIN_OTP_BUTTON")}
      </Button>
      <Link
        style={{ cursor: "pointer" }}
        onClick={() => setLoginFlowStep(LoginFormFlow.GENERIC_STEP)}
      >
        ← {t("login.BACK")}
      </Link>
    </div>
  );
};
